import { useQuery } from "@tanstack/react-query";
import { getClientDetail } from "../API/getClientData";

const useGetClientDetail = (clientCode, enabled = false) => {
  return useQuery({
    queryKey: ["clientDetail", clientCode],
    queryFn: () => getClientDetail(clientCode),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};

export default useGetClientDetail;
